<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div class="flex flex-col p-[20px] pt-[12px] gap-[22px] bg-[#FCFCFC]">
            <div class="h-[74px] flex flex-col items-center">
              <ResourcesIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-[#320B1F1D1F3C]">
                จำนวนที่ใช้ไป
              </span>
            </div>
            <div
              class="max-h-[490px] flex flex-col gap-[12px] px-[10px] py-[14px] rounded-[6px] border-[1px] border-solid border-[#b7b2b5] bg-[#fff] overflow-auto"
            >
              <div class="flex items-start gap-[6px]">
                <div
                  class="min-w-[72px] min-h-[72px] w-[72px] h-[72px] border-[1px] border-solid border-[#F2E7F9]"
                >
                  <img
                    v-if="item.image.image_path"
                    :src="
                      item.image.image_path || 'https://placehold.co/48x48/png'
                    "
                    alt=""
                  />
                  <img
                    v-else
                    :src="
                      item.image ||
                      item.image.image_path ||
                      'https://placehold.co/48x48/png'
                    "
                    alt=""
                  />
                </div>
                <div>
                  <div class="PC_Body1-R !text-[#1F1D1F]">{{ item.name }}</div>
                  <div class="cardLabel">
                    {{ item.unit_name }}
                  </div>
                  <div class="cardLabel">
                    {{ item.category_name }}
                  </div>
                </div>
              </div>
              <!-- <div class="w-full h-[1px] bg-[#DFDCDD]"></div> -->
              <div
                class="w-full flex flex-col items-start gap-[6px] PC_Body2-R !text-[#1F1D1F]"
              >
                <div
                  class="w-full flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                >
                  <span class="title"> ลดจำนวน </span>
                  <!-- <div class="title !text-[#EB5554]">*</div> -->
                </div>
                <div
                  class="flex items-start gap-[6px] PC_Body2-R !text-[#1F1D1F]"
                >
                  <div>จำนวนปัจจุบัน</div>
                  <div>:</div>
                  <div>{{ $numberAndComma(item.quantity) || "0" }}</div>
                </div>
                <div
                  class="flex items-start gap-[6px] PC_Body2-R !text-[#1F1D1F]"
                >
                  <div>อัปเดตยอด</div>
                  <div>:</div>
                  <div v-if="form.quantity == 0" class="!text-[#9B237B]">0</div>
                  <div v-else class="!text-[#9B237B]">
                    {{ $numberAndComma(form.quantityUpdate) || "0" }}
                  </div>
                </div>
                <div class="w-full flex items-center gap-[6px] flex-wrap sm:flex-nowrap">
                  <div class="w-full">
                    <QuantitySelectorComponent
                      :inputClass="'!h-[42px] !min-w-[182px]'"
                      :maxValue="item.quantity"
                      v-model:fieldValue="form.quantity"
                    />
                  </div>
                  <ButtonComponent
                    :bClass="'btn_shadow--32 sm:max-w-[102px]'"
                    :label="'ยอดทั้งหมด'"
                    :disabled="item.quantity == form.quantity"
                    @clicked="allQuantity"
                  />
                </div>
                <div class="w-full flex flex-col gap-[10px]">
                  <div
                    class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                  >
                    <span class="title"> แหล่งที่มา </span>
                    <div class="title !text-[#EB5554]">*</div>
                  </div>
                  <Radio
                    :id="'resources_choice1'"
                    v-model="form.detail.type"
                    :name="'resources_choice1'"
                    :value="1"
                    :label="'ศูนย์พักพิง'"
                  />
                  <div class="pl-[30px]">
                    <SelectBox
                      :searchable="true"
                      inputId="shelter_id"
                      valueKey="id"
                      :options="AllShelter"
                      v-model="form.detail.shelter_id"
                      :placeholder="'เลือกศูนย์พักพิง'"
                      :disabled="form.detail.type == 2"
                      @change="
                        (res) => {
                          form.detail.shelter_id = res.id || '';
                          form.detail.shelter_name = res.name || '';
                        }
                      "
                    />
                  </div>
                  <Radio
                    :id="'resources_choice1'"
                    v-model="form.detail.type"
                    :name="'resources_choice1'"
                    :value="2"
                    :label="'อื่นๆ'"
                  />
                  <div class="pl-[30px]">
                    <Input
                      placeholder="ระบุ"
                      v-model="form.detail.other"
                      :disabled="form.detail.type == 1"
                      :warningMessage="errors.unit_type"
                    />
                  </div>
                  <div
                    class="flex items-center gap-[6px] p-[4px] px-[6px] bg-[#FBEFF8]"
                  >
                    <span class="title"> รายละเอียด อื่นๆ </span>
                  </div>
                  <Input
                    label="Lot no. (ถ้ามี)"
                    placeholder="Lot no. (ถ้ามี)"
                    v-model="form.detail.lot_no"
                  />
                  <!-- datePicker  -->
                  <DatePicker2
                    :containerClass="'w-[calc(33%-0rem)]'"
                    label="วันผลิต/วันหมดอายุ (ถ้ามี)"
                    :id="'birthDate1'"
                    placeholder="เลือกวันเดือนปี"
                    :modelValue="form.detail.exp_date"
                    :isMaxDate="false"
                    @update:modelValue="(date) => selectDate(date)"
                  />
                  <!-- datePicker  -->
                  <Input
                    label="หมายเหตุ (ถ้ามี)"
                    placeholder="หมายเหตุ (ถ้ามี)"
                    v-model="form.detail.reason"
                  />
                  <SelectBox
                    label="ชื่อผู้รับของ"
                    :searchable="true"
                    inputId="recipient_id"
                    valueKey="id"
                    optionToDisplay="fullname"
                    :options="AllUsers"
                    v-model="form.detail.recipient_id"
                    :placeholder="'ชื่อผู้รับของ'"
                    @change="
                      (res) => {
                        form.detail.recipient_id = res.id || '';
                        form.detail.recipient_name = res.fullname || '';
                      }
                    "
                  />
                  <SelectBox
                    label="ชื่อผู้จ่ายของ"
                    :searchable="true"
                    inputId="sender_id"
                    valueKey="id"
                    optionToDisplay="fullname"
                    :options="AllUsers"
                    v-model="form.detail.sender_id"
                    :placeholder="'ชื่อผู้จ่ายของ'"
                    @change="
                      (res) => {
                        form.detail.sender_id = res.id || '';
                        form.detail.sender_name = res.fullname || '';
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="
                  form.quantity <= 0 ||
                  (form.detail.type == 2 && form.detail.other == '') ||
                  (form.detail.type == 1 && form.detail.shelter_id == '') ||
                  form.detail.recipient_id == '' ||
                  form.detail.sender_id == ''
                "
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useProductStore } from "@/pinia/product";
import { useShelterStore } from "@/pinia/shelter";
import { useUsersStore } from "@/pinia/users";
import { storeToRefs } from "pinia";

const productStore = useProductStore();
const shelterStore = useShelterStore();
const { AllShelter } = storeToRefs(shelterStore);
const usersStore = useUsersStore();
const { AllUsers } = storeToRefs(usersStore);

const emptyDetail = () => ({
  type: 1,
  shelter_name: "",
  shelter_id: "",
  other: "",
  lot_no: "",
  exp_date: "",
  reason: "",
  recipient_id: "",
  recipient_name: "",
  sender_id: "",
  sender_name: "",
});

const emptyForm = () => ({
  id: "",
  quantity: "",
  quantityUpdate: "",
  condition: "-1",
  detail: emptyDetail(),
});

const input = emptyForm();

const form = ref({ ...input });
const errors = ref({ ...input });
const item = ref({});
const modalIsOpened = ref(false);

const emit = defineEmits(["status", "open"]);

watch(
  () => Number(form.value.quantity),
  (newVal) => {
    if (newVal) {
      const currentQty = Number(item.value.quantity) || 0;
      const diff = currentQty - newVal;
      form.value.quantityUpdate =
        diff === 0 ? "0" : diff > 0 ? `${diff}` : `${diff}`;
    }
  },
  { immediate: true }
);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  item.value = data;
  form.value = {
    ...emptyForm(),
    id: data.id,
    quantity: "0",
    quantityUpdate: "0",
    shelter_id: item.value.id || "",
  };
  form.value.detail = emptyDetail();
  errors.value = {
    ...emptyForm(),
    detail: emptyDetail(),
  };
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const allQuantity = () => {
  form.value.quantity = item.value.quantity;
};

const save = async () => {
  await productStore
    .updateProductQuantity(form.value)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("open", response.data.data);
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const selectDate = (date) => {
  form.value.detail.exp_date = date;
};

defineExpose({ openModal });
</script>
    
<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>